import Vue, { VNode } from "vue";

Vue.directive("html", {
  inserted(el, binding) {
    el.innerHTML = binding.value;
  },
  update(el, binding) {
    el.innerHTML = binding.value;
  },
});
